import { useParams } from 'react-router';
import {
  SurveyLanguage,
  useSurveyPreviewScreen_SurveyQuery,
} from '@/graphql/generated';
import { LoaderFullscreen } from '@/components/layout/Loader';
import { MessageBox, MessageBoxType } from '@/components/layout/MessageBox';
import {
  SURVEY_RESPONSE_MODE,
  SurveyResponse,
} from '@/components/survey/response/SurveyResponse';
import { SurveyResponseProvider } from '@/components/survey/response/SurveyResponseContext';
import { LanguageScopeWrapper } from '../project/home/LanguageScopeWrapper';

export function SurveyPreviewScreen() {
  const { surveyId } = useParams();

  const { data, loading, error } = useSurveyPreviewScreen_SurveyQuery({
    variables: { id: surveyId || '' },
    skip: !surveyId,
    fetchPolicy: 'network-only',
  });

  if (error) {
    return <MessageBox type={MessageBoxType.Error}>{error.message}</MessageBox>;
  }

  if (data?.questionableSurvey) {
    return (
      <LanguageScopeWrapper
        language={data.questionableSurvey.language || SurveyLanguage.Fr}
      >
        <SurveyResponseProvider surveyId={surveyId ?? ''}>
          <SurveyResponse
            survey={data.questionableSurvey}
            initialResponseMode={SURVEY_RESPONSE_MODE.PREVIEW}
          />
        </SurveyResponseProvider>
      </LanguageScopeWrapper>
    );
  } else {
    if (loading) {
      return (
        <div className="h-screen w-full">
          <LoaderFullscreen />
        </div>
      );
    } else {
      return (
        <MessageBox type={MessageBoxType.Error}>
          Consultation non trouvé
        </MessageBox>
      );
    }
  }
}
